'use client';

import { useState } from 'react';
import { runPipeline, runPipelineOnServer } from '@/lib/pipeline/engine';
import { usePipelineStore } from '@/lib/pipeline/store';
import { useToast } from '@/components/Toast';

type RunMode = 'local' | 'server';

export default function RunControls() {
  const running = usePipelineStore((s) => s.running);
  const clearGraph = usePipelineStore((s) => s.clearGraph);
  const toast = useToast();
  const [mode, setMode] = useState<RunMode>('local');

  const onRun = async () => {
    const res = mode === 'server' ? await runPipelineOnServer() : await runPipeline();
    if (res.ok) toast.success(mode === 'server' ? 'Server run complete' : 'Pipeline complete');
    else toast.error(res.error ?? 'Run failed');
  };

  return (
    <div className="flex items-center gap-2">
      {/* Local / Server toggle */}
      <div className="flex rounded-lg border border-[var(--border-subtle)] overflow-hidden shadow-soft">
        {(['local', 'server'] as RunMode[]).map((m) => (
          <button
            key={m}
            onClick={() => setMode(m)}
            disabled={running}
            className={`h-9 px-3 text-xs font-medium capitalize transition-subtle ${
              mode === m
                ? 'bg-[var(--accent-soft)] text-[var(--accent)]'
                : 'bg-[var(--bg-elevated)] text-[var(--text-muted)] hover:text-[var(--text-primary)]'
            }`}
            title={
              m === 'server'
                ? 'Run on the backend (persistent, survives refresh)'
                : 'Run in the browser'
            }
          >
            {m}
          </button>
        ))}
      </div>

      <button
        onClick={onRun}
        disabled={running}
        className="btn btn-primary h-9 px-5 text-sm font-semibold shadow-soft"
      >
        {running ? 'Running…' : 'Run'}
      </button>
      <button
        onClick={clearGraph}
        disabled={running}
        className="btn btn-ghost h-9 px-3 text-sm shadow-soft"
      >
        Clear
      </button>
    </div>
  );
}
